import { AbstractControl, ValidatorFn } from '@angular/forms';

export function confirmPasswordFormValidator(
  controlName: string,
  matchingControlName: string
): ValidatorFn {
  return (abstractControl: AbstractControl) => {
    const control = abstractControl.get(controlName);
    const matchingControl = abstractControl.get(matchingControlName);

    if (!matchingControl?.value) {
      return null;
    }

    if (control!.value !== matchingControl!.value) {
      const error = { confirmPasswordValidator: 'Passwords do not match.' };
      return error;
    } else {
      return null;
    }
  };
}
